import React from 'react';
import { Plane, Clock, Shield, Car, MapPin, Users, Star, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AirportTransferLanding() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header Section with Split Content */}


            {/* Feature Showcase Section */}
            <section className="pt-14 pb-8 px-0 md:px-6 bg-white">
                <div className="w-[98%] md:max-w-7xl mx-auto">
                    <div className="text-center mb-12">
                        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold     text-slate-800 mb-4">
                            Why Businesses Trust Our
                            <span className="text-emerald-600">Airport Transfer Service</span>
                        </h2>
                        <p className="text-sm md:text-base lg:text-lg text-slate-600 max-w-3xl mx-auto">
                            Experience reliable, professional, and hassle-free airport transfers that facilitate seamless travel for delegates, clients, and employees.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
                        <div className="group bg-gray-50 hover:bg-white p-8 rounded-2xl transition-all duration-300 hover:shadow-2xl">
                            <div className="bg-emerald-600 w-12 h-12 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                                <MapPin className="w-6 h-6 md:w-8 md:h-8 text-white" />
                            </div>
                            <h4 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-3">Strategic Hyderabad Coverage</h4>
                            <p className="text-xs md:text-sm text-slate-600">Expert navigation through busy Hyderabad traffic with precise timing for airport transfers ensuring punctual arrivals.</p>
                        </div>

                        <div className="group bg-gray-50 hover:bg-white p-8 rounded-2xl transition-all duration-300 hover:shadow-2xl">
                            <div className="bg-slate-700 w-12 h-12 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                                <Users className="w-6 h-6 md:w-8 md:h-8 text-white" />
                            </div>
                            <h4 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-3">Delegate & Conference Support</h4>
                            <p className="text-xs md:text-sm text-slate-600">Specialized service for outstation conferences and international delegate arrivals with professional meet-and-greet.</p>
                        </div>

                        <div className="group bg-gray-50 hover:bg-white p-8 rounded-2xl transition-all duration-300 hover:shadow-2xl">
                            <div className="bg-emerald-600 w-12 h-12 md:w-16 md:h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                                <CheckCircle className="w-6 h-6 md:w-8 md:h-8 text-white" />
                            </div>
                            <h4 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-3">Effortless Booking Process</h4>
                            <p className="text-xs md:text-sm text-slate-600">Simple and convenient booking system for arranging transportation effortlessly with 24/7 customer support.</p>
                        </div>
                    </div>

                    <div className="relative bg-gradient-to-r from-gray-100 to-gray-50 rounded-3xl p-6 md:p-12 overflow-hidden">
                        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center relative z-10">
                            <div className="space-y-6">
                                <h3 className="text-xl md:text-2xl font-bold text-slate-800">
                                    Seamless Airport Experience for Every Business Need
                                </h3>
                                <p className="text-sm md:text-base text-slate-600">
                                    From luxury sedans for executives to spacious SUVs for group transfers, our diverse fleet ensures the perfect vehicle for every occasion.
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <Link to="/contact" className="bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 md:px-6 md:py-3 rounded-lg font-semibold transition-all text-sm md:text-base">
                                        Contact Us
                                    </Link>
                                    <Link to="/quote" className="border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-600 hover:text-white px-4 py-2 md:px-6 md:py-3 rounded-lg font-semibold transition-all text-sm md:text-base">
                                        Get a Quote
                                    </Link>
                                </div>
                            </div>

                            <div className="relative">
                                <div className="bg-white rounded-2xl p-2 md:p-4 shadow-2xl">
                                    <img
                                        src="/SeamlessAirport.jpg"
                                        alt="Airport Terminal Professional Service"
                                        className="w-full h-64 object-cover rounded-xl"
                                    />
                                </div>
                                <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-600 rounded-full opacity-10"></div>
                                <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-slate-800 rounded-full opacity-10"></div>
                            </div>
                        </div>

                        <div className="absolute top-0 right-0 w-40 h-40 bg-emerald-600 rounded-full -translate-y-20 translate-x-20 opacity-5"></div>
                        <div className="absolute bottom-0 left-0 w-60 h-60 bg-slate-800 rounded-full translate-y-32 -translate-x-32 opacity-5"></div>
                    </div>
                </div>
            </section>

            <section className="bg-gradient-to-r from-gray-100 via-white to-gray-100 pt-14 pb-8 px-6">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center space-x-2 bg-emerald-100 px-4 py-2 rounded-full mb-4">
                            <Plane className="w-5 h-5 text-emerald-600" />
                            <span className="text-emerald-700 text-sm md:text-base font-semibold">Airport Transfer Services</span>
                        </div>
                        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-800 mb-4">
                            Professional Airport Transfers for
                            <span className="text-emerald-600"> Business Excellence</span>
                        </h1>
                        <p className="text-sm md:text-base lg:text-lg text-slate-600 max-w-3xl mx-auto">
                            PVR CABS offers exceptional airport transfer services designed for businesses hosting delegates or organizing outstation conferences, ensuring seamless travel experiences with punctuality and professionalism.
                        </p>
                    </div>

                    <div className="grid lg:grid-cols-4 gap-6">
                        <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-emerald-600">
                            <Clock className="w-8 h-8 text-emerald-600 mb-3" />
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-2">Punctuality</h3>
                            <p className="text-xs md:text-sm text-slate-600">Meticulous planning ensures delegates arrive on time for important meetings and conferences</p>
                        </div>

                        <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-slate-700">
                            <Shield className="w-8 h-8 text-slate-700 mb-3" />
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-2">Safety First</h3>
                            <p className="text-xs md:text-sm text-slate-600">Prioritizing passenger safety with secure transportation for employees and clients</p>
                        </div>

                        <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-emerald-600">
                            <Star className="w-8 h-8 text-emerald-600 mb-3" />
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-2">Professionalism</h3>
                            <p className="text-xs md:text-sm text-slate-600">Professional drivers with identifiable placards for a welcoming airport experience</p>
                        </div>

                        <div className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-slate-700">
                            <Car className="w-8 h-8 text-slate-700 mb-3" />
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-2">Diverse Fleet</h3>
                            <p className="text-xs md:text-sm text-slate-600">Range of vehicles from SUVs to sedans catering to various preferences and needs</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Service Benefits & CTA Section */}
            <section className="pt-14 pb-8 px-6 bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-slate-800 mb-4">
                            Complete Airport Transfer Solutions
                        </h2>
                        <p className="text-sm md:text-base lg:text-lg text-slate-600 max-w-2xl mx-auto">
                            From arrival to departure, we ensure your business travel needs are handled with utmost care and professionalism.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8 mb-16">
                        <div className="text-center">
                            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                                <Plane className="w-10 h-10 text-emerald-600" />
                            </div>
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-3">Arrival Transfers</h3>
                            <p className="text-xs md:text-sm text-slate-600">Professional meet-and-greet service with identifiable placards for seamless airport pickups</p>
                        </div>

                        <div className="text-center">
                            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                                <MapPin className="w-10 h-10 text-slate-700" />
                            </div>
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-3">Departure Transfers</h3>
                            <p className="text-xs md:text-sm text-slate-600">Timely drop-off services ensuring delegates reach the airport well in advance for their flights</p>
                        </div>

                        <div className="text-center">
                            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                                <Users className="w-10 h-10 text-emerald-600" />
                            </div>
                            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-slate-800 mb-3">Group Transfers</h3>
                            <p className="text-xs md:text-sm text-slate-600">Coordinated transportation for multiple delegates attending conferences or business events</p>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl p-6 md:p-8 shadow-xl">
                        <div className="grid lg:grid-cols-3 gap-6 md:gap-8 items-center">
                            <div className="lg:col-span-2">
                                <h3 className="text-xl md:text-2xl font-bold text-slate-800 mb-4">
                                    Ready to Elevate Your Business Travel Experience?
                                </h3>
                                <p className="text-sm md:text-base text-slate-600 mb-6">
                                    Join leading businesses who trust PVR CABS for reliable, professional, and hassle-free airport transfer services. Impress your delegates and clients with our premium transportation solutions.
                                </p>

                                <div className="flex flex-wrap gap-4">
                                    <Link to="/quote" className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 md:px-6 md:py-3 rounded-lg font-semibold transition-all text-sm md:text-base">
                                        Get Instant Quote
                                    </Link>
                                    <a href="tel:+917993149818">
                                        <button className="border-2 border-slate-800 text-slate-800 hover:bg-slate-800 hover:text-white px-4 py-2 md:px-6 md:py-3 rounded-lg font-semibold transition-all text-sm md:text-base">
                                            Call Now: +917993149818
                                        </button>
                                    </a>

                                </div>
                            </div>

                            <div className="bg-gray-50 rounded-xl p-4 md:p-6">
                                <h4 className="font-bold text-slate-800 mb-4 text-center text-base md:text-lg">Why Choose PVR CABS?</h4>
                                <div className="space-y-3">
                                    <div className="flex items-center space-x-2">
                                        <CheckCircle className="w-4 h-4 text-emerald-600 flex-shrink-0" />
                                        <span className="text-xs md:text-sm text-slate-600">24/7 Airport Service</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <CheckCircle className="w-4 h-4 text-emerald-600 flex-shrink-0" />
                                        <span className="text-xs md:text-sm text-slate-600">Flight Tracking</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <CheckCircle className="w-4 h-4 text-emerald-600 flex-shrink-0" />
                                        <span className="text-xs md:text-sm text-slate-600">Professional Chauffeurs</span>
                                    </div>
                                    <div className="flex items-center space-x-2">
                                        <CheckCircle className="w-4 h-4 text-emerald-600 flex-shrink-0" />
                                        <span className="text-xs md:text-sm text-slate-600">Premium Fleet</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}